@if (this.lead$ | async; as lead) {
  <div
    class="tab-pane fade flex-even active show h-100"
    id="duplicates"
    role="tabpanel"
    aria-labelledby="duplicates-lead-tab"
  >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
            <app-actions-group [actionsGroupName]="'tabView_duplicates'"
                               [model]="lead"
            />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md">
          @if (lead.duplicateLeads && lead.duplicateLeads.length > 0) {
            <app-generic-grid
              style="height: 300px"
              [data]="lead.duplicateLeads"
              [tabViewName]="'duplicates'"
              [currentRowId]="lead.uniqueId"
              [currentRowIdProperty]="'uniqueId'"
            />
          } @else {
            <p class="text-muted" translate>
              LEAD_LBL_DUPLICATES_EMPTY
            </p>
          }
        </div>
      </div>
    </div>
  </div>
}
